module.exports = __webpack_public_path__ + "img/ye.d61828d4.svg";